'use client';

import React, { useMemo } from 'react';

import ProductListingPage from 'components/consumer/ProductListingPage';
import useClearancePageData from './hooks/useClearancePageData';

const ConsumerClearancePage = () => {
  const pageData = useClearancePageData();
  const pageDataWithLayout = useMemo(
    () => ({
      ...pageData,
      layout: 'minimal-with-attributes',
    }),
    [pageData]
  );
  return <ProductListingPage pageData={pageDataWithLayout} />;
};

export default ConsumerClearancePage;
